/**
 * @file date-picker.component.tsx
 * @description Form-control обертка для работы с UI DatePicker компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @components/ui/base/date-picker]
 * @related-files [@components/ui/base/date-picker/date-picker.tsx]
 */

import { Controller, Control } from 'react-hook-form';
import { DatePicker as UIDatePicker } from '@components/ui/base/date-picker';
import { ComponentProps } from 'react';

/**
 * Props для form-control компонента DatePicker с интеграцией react-hook-form
 */
interface IDatePicker extends ComponentProps<typeof UIDatePicker> {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
    /** Дополнительный обработчик изменений с именем поля и новым значением */
    onChangeHandler?: (name: string, newValue: number | number[] | null) => void;
}

export const DatePicker = ({ control, name, onChangeHandler, ...props }: IDatePicker) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <UIDatePicker
                    onChange={(newValue: number | number[] | null) => {
                        field.onChange(newValue);
                        onChangeHandler && onChangeHandler(name, newValue);
                    }}
                    onBlur={field.onBlur}
                    value={field.value}
                    {...props}
                />
            )}
        />
    );
};
